module.exports = __webpack_public_path__ + "static/media/soraRecording.af06a31d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/soraRecording.svg
// module id = 847
// module chunks = 0